// useSavedHeatmaps.js — Composable para obtener la lista de heatmaps guardados
//
// Uso:
//   import { useSavedHeatmaps } from '@/composables/useSavedHeatmaps';
//   const { heatmaps, loading, refresh } = useSavedHeatmaps();
//
// Cachea por 60 segundos.

import { ref } from 'vue';
import axios from 'axios';

const API_BASE_URL = 'https://dash-visaovip.kompara.tech/api';

const heatmaps = ref([]);
const loading = ref(false);
const lastFetched = ref(0);
const CACHE_MS = 60_000;

function getAuthHeaders() {
  const token = localStorage.getItem('token_precios');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

async function fetchHeatmaps(force = false) {
  const now = Date.now();
  if (!force && now - lastFetched.value < CACHE_MS && heatmaps.value.length > 0) {
    return;
  }
  loading.value = true;
  try {
    const response = await axios.get(`${API_BASE_URL}/saved-heatmaps/`, getAuthHeaders());
    heatmaps.value = response.data || [];
    lastFetched.value = now;
  } catch (e) {
    console.warn('[useSavedHeatmaps] fetch failed:', e?.message || e);
    heatmaps.value = [];
  } finally {
    loading.value = false;
  }
}

export function useSavedHeatmaps() {
  if (heatmaps.value.length === 0 && !loading.value) {
    fetchHeatmaps();
  }
  return {
    heatmaps,
    loading,
    refresh: () => fetchHeatmaps(true),
  };
}